import { useSelector } from "react-redux";
import { PlusIcon } from "app-v2";
import { useRouter } from "next/router";
import AuctionOverviewComponent from "./AuctionOverviewComponent";
import { useEffect, useRef, useState } from "react";
import EventStatusComponent from "./EventStatusComponent";
import OngoingAuctionsComponent from "./OngoingAuctionsComponent";
import Pusher from "pusher-js";
import {
  getAuctionEventsWithPagination,
  getBankerDashboardEventsCount,
} from "services";
import EventsCalendar from "./EventsCalendar";

export const BankerHomepage = () => {
  const router = useRouter();
  const [liveEventData, setLiveEventData] = useState([]);
  const [weeklyEventsData, setWeeklyEventsData] = useState([]);
  const [events, setEvents] = useState([]);
  const eventsRef = useRef(events);
  const userProfile = useSelector((state: any) => {
    return state.bankerAuth.user?.profile;
  });
  const currentBranch = useSelector((state: any) => {
    return state.bankerAuth.currentBranch;
  });

  const handleLiveEventsChange = (uuid: string, status: "live" | "end") => {
    if (status === "live") {
      // Find event in the global events list
      const eventToAdd: any = eventsRef.current.find(
        (e: any) => e.uuid === uuid,
      );
      if (eventToAdd) {
        setLiveEventData((prev: any) => {
          // prevent duplicates
          if (prev.some((e: any) => e.uuid === uuid)) return prev;
          return [...prev, { ...eventToAdd, status: "live" }];
        });
      }
    } else if (status === "end") {
      // Remove from liveEventsData
      setLiveEventData((prev: any) => prev.filter((e: any) => e.uuid !== uuid));
    }
  };

  const fetchLiveEventData = async () => {
    try {
      const payload = {
        status: "live",
      };
      const response: any = await getAuctionEventsWithPagination(payload);

      if (response) {
        setLiveEventData(response?.data);
      }
    } catch (err) {
      console.log("error", err);
    }
  };

  const fetchWeeklyEventsData = async () => {
    try {
      const fetchResult = async () => {
        const today = new Date();
        // const today = new Date("2025-02-17T00:00:00Z");
        const startOfWeek = new Date(today);
        startOfWeek.setDate(today.getDate() - today.getDay());
        startOfWeek.setHours(0, 0, 0, 0);

        const endOfWeek = new Date(startOfWeek);
        endOfWeek.setDate(startOfWeek.getDate() + 6);
        endOfWeek.setHours(23, 59, 59, 999);

        const payload = {
          startDate: startOfWeek
            ? new Date(
                Date.UTC(
                  startOfWeek.getFullYear(),
                  startOfWeek.getMonth(),
                  startOfWeek.getDate(),
                  0,
                  0,
                  0,
                  0,
                ),
              ).toISOString()
            : "",
          endDate: endOfWeek
            ? new Date(
                Date.UTC(
                  endOfWeek.getFullYear(),
                  endOfWeek.getMonth(),
                  endOfWeek.getDate(),
                  23,
                  59,
                  59,
                  999,
                ),
              ).toISOString()
            : "",
          type: "weekly-data",
        };
        const res: any = await getBankerDashboardEventsCount(payload);
        if (res) {
          setWeeklyEventsData(res.data);
        }
      };
      fetchResult();
    } catch (err) {
      console.log("error", err);
    }
  };
  useEffect(() => {
    const fetchData = async () => {
      const results = await Promise.allSettled([
        fetchLiveEventData(),
        fetchWeeklyEventsData(),
      ]);
      results.forEach((result, index) => {
        if (result.status === "rejected") {
          console.error(`Banker home fetch ${index} failed:`, result.reason);
        }
      });
    };
    fetchData();
  }, [currentBranch]);

  useEffect(() => {
    eventsRef.current = events;
  }, [events]);

  useEffect(() => {
    // Pusher.logToConsole = false;
    const pusher = new Pusher(`${process.env.NEXT_PUBLIC_PUSHER_KEY}`, {
      cluster: process.env.NEXT_PUBLIC_PUSHER_CLUSTER,
    });

    const channelId = `update-dashboard`;
    const channel = pusher.subscribe(channelId);

    channel.bind("auction_event_has_started", (data: any) => {
      if (data) {
        handleLiveEventsChange(data.event_uuid, "live");
      }
    });

    channel.bind("auction_event_has_ended", (data: any) => {
      if (data) {
        handleLiveEventsChange(data.event_uuid, "end");
      }
    });

    pusher.connection.bind("error", function (err: any) {
      if (err?.error?.data?.code === 4004) {
        console.log(">>> detected limit error");
      } else if (err?.data?.code === 1006) {
        // Websocket: CLOSED ABNORMALLY
      }
    });

    pusher.connection.bind("disconnected", function (err: any) {
      console.log(">>> disconnected");
    });

    pusher.connection.bind("connected", function (err: any) {
      console.log("connected", pusher.sessionID);
    });

    return function cleanup() {
      pusher.disconnect();
    };
  }, [userProfile]);
  return (
    <div className="px-4 lg:px-8 pt-6 ">
      <div className="flex justify-between items-start sm:items-center ">
        <p className="font-openSans font-normal text-[24px] leading-8 lg:text-web-subheading lg:leading-6">
          Hello {userProfile?.bio?.full_name ? userProfile.bio.full_name : ""},{" "}
          <br className="sm:hidden" />
          Welcome Back
        </p>
        <button
          onClick={() => {
            router.push("/dashboard/events/create");
          }}
          className="flex justify-center items-center w-[125px] gap-1 bg-black font-openSans  text-mobile-body-sm text-white sm:text-sm px-2 py-2 sm:py-3 rounded-[12px]"
        >
          <PlusIcon />
          Create Event
        </button>
      </div>
      <div className="mt-[18px] mid:flex mid:space-x-4">
        <div className="w-full">
          <AuctionOverviewComponent />
          <EventStatusComponent
            events={events}
            setEvents={setEvents}
            eventsRef={eventsRef}
            outerContainerClass="mt-5"
          />
          <EventsCalendar events={weeklyEventsData} />
        </div>
        <OngoingAuctionsComponent eventsData={liveEventData} />
      </div>
    </div>
  );
};

export default BankerHomepage;
